import type { PlaceholderProductListingOpts } from '@/cms/PlaceholderProductListing';
import { PlaceholderProductListing } from '@/cms/PlaceholderProductListing';
import { HeroProductListing } from '@/components/HeroProductListing';
import type { HeroProductListingOpts } from '@/components/HeroProductListing/types';
import type {
  ContentfulHeroProductListingFragment,
  ContentfulPlaceholderFragment,
} from '@/graphql/contentful/api';
import type {
  ContentType,
  PageSectionsOpts,
  RenderContentfulSection,
} from '@/integrations/contentful';
import {
  getHeroProductListingType,
  getOptsForType,
  renderContentfulSection,
} from '@/integrations/contentful';

export type AllTheStrapsSectionOpts = PageSectionsOpts<
  PlaceholderProductListingOpts | HeroProductListingOpts
>;

export const renderContentfulAllTheStrapsSection: RenderContentfulSection<
  AllTheStrapsSectionOpts
> = (data, sectionOpts, extraDataRecord, draftMode) => {
  const section = renderContentfulSection(
    data,
    sectionOpts,
    extraDataRecord,
    draftMode,
  );
  if (section) {
    return section;
  }

  let props = null;
  let opts = null;
  const typename = data?.__typename as ContentType;

  switch (typename) {
    case 'Placeholder':
      props = data as ContentfulPlaceholderFragment;
      return renderPlaceholders(props, sectionOpts);

    case 'HeroProductListing':
      props = data as ContentfulHeroProductListingFragment;
      opts = getOptsForType<HeroProductListingOpts>(
        'HeroProductListing',
        sectionOpts,
      ).find((opt) => opt.opts?.type === 'all the straps')?.opts;
      return opts ? (
        <HeroProductListing
          {...props}
          {...opts}
          data-test-id='HeroProductListingAllTheStraps'
          type={getHeroProductListingType(props, opts)}
        />
      ) : null;

    default:
      return null;
  }
};

const renderPlaceholders = (
  props: ContentfulPlaceholderFragment,
  sectionOpts?: AllTheStrapsSectionOpts,
) => {
  let opts = null;

  if (props.type === 'product listing') {
    opts = getOptsForType<PlaceholderProductListingOpts>(
      'Placeholder',
      sectionOpts,
    ).find((opt) => opt.opts?.type === 'product listing')?.opts;

    return opts ? (
      <PlaceholderProductListing
        {...props}
        {...opts}
        data-test-id='PlaceholderProductListingProductListing'
        isMostRelevantCta={true}
        productType='watch'
      />
    ) : null;
  }
  return null;
};
